import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAdmin } from './auth';

const AdminRoute = ({ children }) => {
  const location = useLocation();
  if (!isAdmin()) {
    return <Navigate to="/connexion" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default AdminRoute;
